<template>
  <div class="indexBox">
    <div class="bigImg">
      <swiper class="swiperBox" v-if="controlSwiper" ref="mySwiper" :options="swiperOption"> 
        <div class="swiper-slide">
          <img src="../../static/index/banner.png" />
        </div>
        <div @click="jumpClick" class="swiper-slide">
          <img src="/activity/autumnOct/activity_pc1.jpg" />
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="indexTitle">
      <!-- 轻松黄金交易，品鉴愉悦人生 -->
      <img src="../../static/index/qshjjy.png" alt="">
    </div>
    <div class="craigBox">
      <ul @mouseleave="totalLeave">
        <li @mouseover="mouseOver(1)" @click="wapExpand(1)"
            @mouseleave="mouseLeave(1)" 
            ref="liFirst"
            :class="controlImg.baozhiImgs ? 'bzBkgImg' : ''">
          <img v-if="!controlImg.baozhiImgs" class="icon" :src='controlImg.baozhiImgs ? baozhiImgs[0] : baozhiImgs[1]' alt="">
          <p v-if="!controlImg.baozhiImgs" :class="controlImg.baozhiImgs ? 'textColor' : ''">
            <span>保值性</span>
            <span>时光流转 价值永存</span>
          </p>
          <div class="wanzhengText" v-if="controlImg.baozhiImgs" >
            <img src="../../static/index/baozhiIcon.png" alt="">
            <!-- <p>时光流转  价值永存</p>
            <p>从古代起黄金便已开始被当作货币来交易，流传千年经久不衰，他的价值不论国界，不分币种，是全世界公认保值性极高的贵金属。</p> -->
            <img style="width:100%; height: auto; margin-top: 30px" src="../../static/index/aa.png" alt="">
          </div>
          <img class="btmBanner" :class="controlImg.baozhiImgs ? 'OpacityImg' : ''" src="../../static/index/jiaohu/bzBanner.png" alt="">
        </li>
        <li ref="liSecond"
            @mouseover="mouseOver(2)" @click="wapExpand(2)"
            @mouseleave="mouseLeave(2)"
            :class="controlImg.sxjzImgs ? 'sxjzBkgImg' : ''">
          <img v-if="!controlImg.sxjzImgs" class="icon" :src='controlImg.sxjzImgs ? sxjzImgs[0] : sxjzImgs[1]' alt="">
          <p v-if="!controlImg.sxjzImgs" :class="controlImg.sxjzImgs ? 'textColor' : ''">
            <span>双向机制</span>
            <span>进退自如 无惧牛熊</span>
          </p>
          <div class="wanzhengText" v-if="controlImg.sxjzImgs" >
            <img src="../../static/index/jiaohu/sxjz.png" alt="">
            <!-- <p>进退自如 无惧牛熊</p>
            <p>黄金是可以双向交易的产品，既可以做多也可以做空，选对行情两边皆是机会。因此在国际金融环境毕竟动荡的今天，选择黄金能对冲很多风险。</p> -->
            <img style="width:100%; height: auto; margin-top: 30px" src="../../static/index/dd.png" alt="">
          </div>
          <img class="btmBanner" :class="controlImg.sxjzImgs ? 'OpacityImg' : ''" src="../../static/index/sxjzBanner.png" alt="">
        </li>
        <li ref="liThird"
            @mouseover="mouseOver(3)" @click="wapExpand(3)"
            @mouseleave="mouseLeave(3)"
            :class="controlImg.sctmImgs ? 'sctmBkgImg' : ''">
          <img v-if="!controlImg.sctmImgs" class="icon" :src='controlImg.sctmImgs ? sctmImgs[0] : sctmImgs[1]' alt="">
          <p v-if="!controlImg.sctmImgs" :class="controlImg.sctmImgs ? 'textColor' : ''">
            <span>市场透明</span>
            <span>所见即所得</span>
          </p>
          <div class="wanzhengText" v-if="controlImg.sctmImgs" >
            <img src="../../static/index/jiaohu/sctm.png" alt="">
            <img style="width:100%; height: auto; margin-top: 30px" src="../../static/index/bb.png" alt="">
          </div>
          <img class="btmBanner" :class="controlImg.sctmImgs ? 'OpacityImg' : ''" src="../../static/index/sctmBanner.png" alt="">
        </li>
        <li ref="liFourth"
            @mouseover="mouseOver(4)" @click="wapExpand(4)"
            @mouseleave="mouseLeave(4)"
            :class="controlImg.jylhImgs ? 'jylhkgImg' : ''">
          <img v-if="!controlImg.jylhImgs" class="icon" :src='controlImg.jylhImgs ? jylhImgs[0] : jylhImgs[1]' alt="">
          <p v-if="!controlImg.jylhImgs" :class="controlImg.jylhImgs ? 'textColor' : ''">
            <span>交易灵活</span>
            <span>随时随地 皆可操作</span>
          </p>
          <div class="wanzhengText" v-if="controlImg.jylhImgs" >
            <img src="../../static/index/jiaohu/jylh.png" alt="">
            <img style="width:100%; height: auto; margin-top: 30px" src="../../static/index/cc.png" alt="">
          </div>
          <img class="btmBanner" :class="controlImg.jylhImgs ? 'OpacityImg' : ''" src="../../static/index/jylhBanner.png" alt="">
        </li>
      </ul>
    </div>
    <div class="indexTitle">
      <!-- 专注黄金交易，一站式管家服务 -->
      <img src="../../static/index/zzhjjy.png" alt="">
    </div>
    <div class="serveBox">
      <div class="sbControl">
        <ul @mouseover="tabClick(1)" @click="tabClick(1)"
            :class="controlDiv === 1 ? 'ulBottom' : ''">
          <li>
            <i :class="controlDiv === 1 ? 'svgColor' : ''" 
               class="iconfont icon-zhuanyequanwei"></i>
            <span>黃金交易平台</span>
          </li>
          <li>香港黄金交易所081行员</li>
        </ul>
        <ul @mouseover="tabClick(2)" @click="tabClick(2)"
            :class="controlDiv === 2 ? 'ulBottom' : ''">
          <li>
            <i :class="controlDiv === 2 ? 'svgColor' : ''" 
               class="iconfont icon-49"></i>
            <span>资金安全</span>
          </li>
          <li>出金自由</li>
        </ul>
        <ul @mouseover="tabClick(3)" @click="tabClick(3)"
            :class="controlDiv === 3 ? 'ulBottom' : ''">
          <li>
            <i :class="controlDiv === 3 ? 'svgColor' : ''" 
               class="iconfont icon-rencaifuwu"></i>
            <span>服务专业</span>
          </li>
          <li>7*24小时客服</li>
        </ul>
        <ul @mouseover="tabClick(4)" @click="tabClick(4)"
            :class="controlDiv === 4 ? 'ulBottom' : ''">
          <li>
            <i :class="controlDiv === 4 ? 'svgColor' : ''" 
               class="iconfont icon-huodongliwu"></i>
            <span>丰富活动</span>
          </li>
          <li>超级点差，活动优惠</li>
        </ul>
        <ul @mouseover="tabClick(5)" @click="tabClick(5)"
            :class="controlDiv === 5 ? 'ulBottom' : ''">
          <li>
            <i :class="controlDiv === 5 ? 'svgColor' : ''" 
               class="iconfont icon-gongyouyunzhujishenqingliucheng-02"></i>
            <span>强大软件</span>
          </li>
          <li>全新智能软件化</li>
        </ul>
      </div>
      <div class="sbShow">
        <div class="showChild" v-if="controlDiv === 1">
          <img src="../../static/index/jiaohu/floorBanner.png" alt="">
          <div>
            <!-- 红狮金业，获香港黄金交易所监管，属香港黄金交易所AA类行员<br/>
            多次获得“最佳贵金属交易平台金企” -->
            <img src="../../static/index/craigOne.png?v=5" alt="">
          </div>
        </div>
        <div class="showChild" v-if="controlDiv === 2">
          <img src="../../static/index/jiaohu/anquan.png" alt="">
          <div>
            <!-- 出入金没有额外规则限制，可以随时出金，最快只<br/>
            需3s即可出金 -->
            <img src="../../static/index/craigTwo.png?v=7" alt="">
          </div>
        </div>
        <div class="showChild" v-if="controlDiv === 3">
          <img src="../../static/index/jiaohu/fuwu.png" alt="">
          <div>
            <img src="../../static/index/craigThree.png" alt="">
          </div>
        </div>
        <div class="showChild" v-if="controlDiv === 4">
          <img src="../../static/index/jiaohu/huodong.png" alt="">
          <div>
            <img src="../../static/index/craigFour.png" alt="">
          </div>
        </div>
        <div class="showChild" v-if="controlDiv === 5">
          <img src="../../static/index/jiaohu/ruanjian.png" alt="">
          <div>
            <img src="../../static/index/craigFive.png" alt="">
          </div>
        </div>
      </div>
    </div>
  
    <!-- <div class="webSocket" :class="websocketScrollTop ? 'fixedWebSocket':''">
      <div class="wssBox">
        <ul>
          <li class="liFirst">
            <span>伦敦金</span>
            <img src="../../static/index/ldj.png" alt="">
          </li>
          <li class="liSecond">
            <p>
              <span :class="London.controlPic ? 'classRed' : 'classGreen' ">{{London.gold}}</span>
              <img :src="London.controlPic ? LondonImg[0] : LondonImg[1]" alt="">
            </p>
            <p>
              <span>{{London.goldRise}}</span>
              <span>{{London.goldPer}}</span>
            </p>
          </li>
        </ul>
        <ul>
          <li class="liFirst">
            <span>伦敦银</span>
            <img src="../../static/index/ldy.png" alt="">
          </li>
          <li class="liSecond">
            <p>
              <span :class="London.controlPicOther ? 'classRed' : 'classGreen' ">{{London.silver}}</span>
              <img :src="London.controlPicOther ? LondonImg[0] : LondonImg[1]" alt="">
            </p>
            <p>
              <span>{{London.silverRise}}</span>
              <span>{{London.silverPer}}</span>
            </p>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>
<script>
  import { base64ToFloat32 } from '../../utils/tools';
  import { analyticalData } from '../../utils/tools';
  import { quote,quoteTime } from '../../api/info';
  import { wapMixin } from '../../utils/device';
  // import pdf from 'vue-pdf';
  export default {
    name: 'Index',
    mixins: [wapMixin],
    data() {
      return {
        baozhiImgs:[
          require('../../static/index/baozhiIcon.png'),
          require('../../static/index/jiaohu/bzx.png'),
        ],
        sxjzImgs:[
          require('../../static/index/jiaohu/sxjz.png'),
          require('../../static/index/sxjzIcon.png'),
        ],
        sctmImgs:[
          require('../../static/index/jiaohu/sctm.png'),
          require('../../static/index/sctmIcon.png'),
        ],
        jylhImgs:[
          require('../../static/index/jiaohu/jylh.png'),
          require('../../static/index/jylhIcon.png'),
        ],
        LondonImg:[
          require('../../static/index/jiaohu/up.png'),
          require('../../static/index/jiaohu/down.png'),
        ],
        selectedImg: require('../../static/index/yuandian.png'),
        controlSwiper: false,
        // swiper 参数
        swiperOption: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          grabCursor:true,
          loop: true,
          preventClicks : true,
           //自动播放
          autoplay: {
            delay: 3000, //延迟播放下一张图片
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            // dynamicBullets: true,
            // type:'custom',
            // renderCustom: function (swiper, current, total) {
            //   if(current === 1){
            //     return '<span class="swiperOne"><li><span></span></li><span class="swiperOneSpan"></span><span></span></span>';
            //   }else if(current === 2){
            //     return `<span class="swiperTwo"><span></span><li><span></span></li><span></span></span>`;
            //   }else{
            //     return `<span class="swiperThree"><span></span><span class="swiperThreeSpan"></span><li><span></span></li></span>`;
            //   }
            // }
          },
        },
        // 控制craigBox
        controlImg:{
          baozhiImgs: true,
          sxjzImgs: false,
          sctmImgs: false,
          jylhImgs: false,
        },
        // 控制serveBox
        controlDiv:1,
        // 控制websocket模块是否定位
        websocketScrollTop:false,
        craigCao: 0,
        London:{
          gold: '--',
          silver: '--',
          goldRise: '0.0',
          silverRise: '0.0',
          goldPer: '0.00%',
          silverPer: '0.00%',
          controlPic: true,
          controlPicOther: true,
        },
        goldCl:'',
        silverCl:'',
      }
    },
    created(){
      // 自动切换serveBox
      this.serveTimer = setInterval(this.updateDiv, 4000);
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
      // wap端默认全部收起，改为点击展开
      if(this.isWap){
        this.controlImg.baozhiImgs = false;
      }
    },
    beforeDestroy(){
      clearInterval(this.serveTimer);
    },
    mounted() {
      // 初始化websocket
      // this.initWebSocket('wss://tradeapi-pm-hq3.mcitj.com:4433/quote');
      // window.addEventListener("scroll", this.handleScroll);

      // // 初始化昨收
      // this.initYesterday({goods: "GOLD,SILVER"});
      // // 初始化实时行情
      // setInterval(()=>{
      //   this.initRealtime({goods: "GOLD,SILVER"});
      // },1000)
    },
    methods: {
      // 获取昨收
      initYesterday(attr){
        quote(attr).then(res=>{
          this.goldCl = res.dt.list[0].close;
          this.silverCl = res.dt.list[1].close;
        })
      },
      initRealtime(attr){
        quoteTime(attr).then(res=>{
          this.London.gold = res.dt.list[0].bid;
          this.London.silver = res.dt.list[1].bid;
          // 黄金 实时与昨收比较大小 决定显示图片
          if(Number(this.goldCl) < Number(this.London.gold)){
            this.London.controlPic = true;
          }else{
            this.London.controlPic = false;
          }
          // 白银 实时与昨收比较大小 决定显示图片
          if(Number(this.silverCl) < Number(this.London.silver)){
            this.London.controlPicOther = true;
          }else{
            this.London.controlPicOther = false;
          }
          // 黄金 计算涨幅;
          this.London.goldRise = (Number(this.London.gold) - Number(this.goldCl)).toFixed(2);
          // 计算百分比（涨幅/昨收）
          this.London.goldPer = ((this.London.goldRise/this.goldCl)*100).toFixed(2) + '%';
          // 白银 涨幅
          this.London.silverRise =  (Number(this.London.silver) - Number(this.silverCl)).toFixed(3);
          // 计算百分比（涨幅/昨收）
          this.London.silverPer = ((this.London.silverRise/this.silverCl)*100).toFixed(2) + '%';
        })
      },
      handleScroll () { //改变元素#searchBar的top值
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop > 1000){
          this.websocketScrollTop = true;
        }else{
          this.websocketScrollTop = false;
        }
      },
      // 切换serveBox的方法
      updateDiv(){
        if(this.controlDiv < 5){
          this.controlDiv = this.controlDiv + 1;
        }else{
          this.controlDiv = 1;
        } 
      },
      // websocket 方法
      initWebSocket(src) {
        const wsuri = src;
        this.websock = new WebSocket(wsuri);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen() {
        let actions = { 't': 7, 'd': { 'k': 0 }};
        this.websocketsend(JSON.stringify(actions));
      },
      websocketonerror() {
        let _this = this;
        console.log("连接建立失败");
        this.initWebSocket('wss://tradeapi-pm-hq2.mcrubly.com:4433/quote');
      },
      websocketonmessage(e) {
        const data = JSON.parse(e.data)
        if (data.t === 0) {
          for (const iterator of data.d) {
            const blob = window.atob(iterator.q)
            const symbol = analyticalData(data.d[0].q||"",5);
            // console.log(symbol);
            if(symbol.SymbolName.slice(0,4) == 'GOLD'){
              // 黄金
              this.London.gold = symbol.Bid.toFixed(3);
              let gold = symbol.Bid;
              if(Number(gold) > Number(this.London.gold)){
                this.London.controlPic = true;
              }else{
                this.London.controlPic = false;
              }
            }else if(symbol.SymbolName.slice(0,6) == 'SILVER'){
              // 白银
              this.London.silver = symbol.Bid.toFixed(3);
              let silver = symbol.Bid;
              if(Number(silver) > Number(this.London.silver)){
                this.London.controlPicOther = true;
              }else{
                this.London.controlPicOther = false;
              }
            }
          }
        }else if (data.t === 5) {
          console.log('t=5');
          let open = data.d.filter(item => {
            if (/(GOLD|SILVER)/.test(item.n)) {
              return item.n
            }
          })
          open.forEach(element => {
            if(element.n == 'GOLD'){
              // 黄金
              this.goldCl =  element.cl;
            }else if(element.n == 'SILVER'){
              // 白银
              this.silverCl = element.cl;
            }
          });
        }
        // 黄金 计算涨幅;
        this.London.goldRise = (Number(this.London.gold) - Number(this.goldCl)).toFixed(2);
        // 计算百分比（涨幅/昨收）
        this.London.goldPer = ((this.London.goldRise/this.goldCl)*100).toFixed(2)+ '%';
        // 白银 涨幅
        this.London.silverRise =  (Number(this.London.silver) - Number(this.silverCl)).toFixed(3);
        // 计算百分比（涨幅/昨收）
        this.London.silverPer = ((this.London.silverRise/this.silverCl)*100).toFixed(2)+ '%';
      },
      websocketsend(Data) {
        this.websock.send(Data);
      },
      websocketclose(e) {
        console.log("断开连接", e);
      },
      // wap端点击展开/收起（PC端不生效，保持hover交互）
      wapExpand(attr){
        if(!this.isWap) return;
        const keys = ['baozhiImgs','sxjzImgs','sctmImgs','jylhImgs'];
        const current = keys[attr - 1];
        const isOpen = this.controlImg[current];
        keys.forEach(key=>{
          this.controlImg[key] = false;
        })
        this.controlImg[current] = !isOpen;
      },
      // 鼠标移入事件
      mouseOver(attr){
        // wap端交由wapExpand处理，避免触摸触发的hover事件干扰
        if(this.isWap) return;
        switch (attr) {
          case 1:
            this.controlImg.baozhiImgs = true;
            break;
          case 2:
            this.controlImg.sxjzImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
          case 3:
            this.controlImg.sctmImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
          case 4:
            this.controlImg.jylhImgs = true;
            this.controlImg.baozhiImgs = false;
            break;
        }
      },
      // 鼠标移出事件
      mouseLeave(attr){
        if(this.isWap) return;
        switch(attr){
          case 1:
            this.controlImg.baozhiImgs = false;
            break;
          case 2:
            this.controlImg.sxjzImgs = false;
            break;
          case 3:
            this.controlImg.sctmImgs = false;
            break;
          case 4:
            this.controlImg.jylhImgs = false;
            break;
        }
      },
      // 鼠标移出整个box时，设置默认展开栏
      totalLeave(){
        if(this.isWap) return;
        this.controlImg.baozhiImgs = true;
      },
      // tabbar点击事件
      tabClick(attr){
        switch(attr){
          case 1:
            this.controlDiv = attr;
            break;
          case 2:
            this.controlDiv = attr;
            break;
          case 3:
            this.controlDiv = attr;
            break;
          case 4:
            this.controlDiv = attr;
            break;
          case 5:
            this.controlDiv = attr;
            break;
        }
      },
      // 点击跳转到专题页(wap端跳wap版专题)
      jumpClick(){
        this.$router.push({
          name: this.isWap ? 'autumnOctWap' : 'autumnOctPC',
        })
      },
    },
    computed: {
      //计算高度
      computeHeight() {
        let screenHeight = document.body.scrollTop;
        console.log(screenHeight);
        if (screenHeight > 415) {
          return '550px';
        } else {
          return '250px';
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .indexBox{
    width: 100%;
    .bigImg{
      width: 100%;
      height: 500px;
      background: url('../../static/index/banner.png') no-repeat;
      background-size: cover;
      /deep/ .swiper-container{
        .swiper-pagination{
          .swiper-pagination-bullet-active{
            background-color: #e1352a;
          }
        }
      }
    }
    .indexTitle{
      font-size: 28px;
      color: #121212;
      box-sizing: border-box;
      padding: 35px 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .craigBox{
      width: 100%;
      box-sizing: border-box;
      padding: 60px 0;
      background: url('../../static/index/changeBanner.png') no-repeat;
      background-size: cover;
      ul{
        width: 1130px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        li{
          width: 25%;
          height: 400px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          box-sizing: border-box;
          border-right: 5px solid #f8f8f8;
          padding: 80px 0 0 70px;
          position: relative;
          background-color: #fff;
          .btmBanner{
            position: absolute;
            right: 0;
            bottom: 0;
          }
          p{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            span{
              font-size: 14px;
              color: #6d6d6d;
            }
            span:nth-child(1){
              font-size: 16px;
              font-weight: 600;
              color: #121212;
            }
          }
        }
        .wanzhengText{
          width: 65%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end !important;
          align-items: flex-start;
          p{
            color: #fff;
            margin: 0;
            text-align: justify;
            line-height: 26px;
          }
          p:nth-child(2){
            font-size: 22px;
            color: #fff;
            margin: 30px 0 10px;
          }
        }
        .bzBkgImg{
          background: url('../../static/index/baozhiBanner.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .sxjzBkgImg{
          background: url('../../static/index/jiaohu/jzBanner.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .sctmBkgImg{
          background: url('../../static/index/jiaohu/scBanner.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        .jylhkgImg{
          background: url('../../static/index/jiaohu/jyBanner.png') no-repeat;
          background-size: cover;
          width: 45%;
        }
        li .textColor span{
          color: #fff !important;
        }
        li .OpacityImg{
          display: none;
        }
      }
    }
    .serveBox{
      width: 100%;
      .sbControl{
        width: 1130px;
        height: 110px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #e2e2e2;
        .ulBottom{
          border-bottom: 4px solid #d52226;
        }
        ul{
          width: 20%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          cursor: pointer;
          li{
            display: flex;
            justify-content: center;
            align-items: flex-start;
            font-size: 15px;
            color: #6d6d6d;
            margin-bottom: 10px;
            .svgColor{
              color: #d52226;
            }
            span{
              font-size: 18px;
              color: #121212;
              margin-left: 10px;
            }
          }
        }
      }
      .sbShow{
        width: 100%;
        .showChild{
          width: 100%;
          height: 402px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          img{
            width: 50%;
            margin-top: 25px;
          }
          div{
            width: 50%;
            // min-width: 950px;
            height: 400px;
            display: flex;
            justify-content: center;
            align-items: center;
            line-height: 30px;
            color: #121212;
            background: url('../../static/index/jiaohu/textBanner.png') no-repeat;
            background-size: cover;
          }
        }
      }
    }
    .webSocket{
      width: 100%;
      height: 140px;
      background: url('../../static/index/ldjyBanner.png') no-repeat;
      background-size: cover;
      position: fixed;
      bottom: 0;
      .wssBox{
        width: 60%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        ul{
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          li{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .liFirst{
            span{
              font-size: 19px;
              color: #121212;
            }
          }
          .liSecond{
            height: 60px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            margin-left: 70px;
            p{
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0px;
              span{
                font-size: 18px;
              }
              .classRed{
                color: #d52226;
              }
              .classGreen{
                color: #18a450;
              }
              img{
                width: 18px;
                height: auto;
                margin-left: 10px;
              }
            }
            p:nth-child(2){
              margin-bottom: 10px;
              span{
                font-size: 14px;
                color: #6d6d6d;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
    .fixedWebSocket{
      position: inherit;
    } 
  }
  /deep/ #box{
    margin-top: 100px;
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    .indexBox{
      .bigImg{
        width: 100%;
        height: 0;
        // 750 * 920 的wap专用banner，按比例撑高
        padding-top: 122.66%;
        background: url('../../static/index/wapImg/banner.jpg') no-repeat;
        background-size: 100% 100%;
      }
      .indexTitle{
        padding: 25px 0;
        img{
          width: 68%;
          max-width: 388px;
          height: auto;
        }
      }
      .craigBox{
        padding: 5px 0 15px;
        background-size: cover;
        ul{
          width: 100%;
          box-sizing: border-box;
          padding: 0 12px;
          flex-direction: column;
          align-items: stretch;
          li{
            width: 100% !important;
            height: auto;
            min-height: 88px;
            box-sizing: border-box;
            padding: 18px 15px;
            border-right: none;
            margin-bottom: 10px;
            justify-content: center;
            .icon{
              width: 42px;
              height: auto;
            }
            p{
              margin: 8px 0 0;
              span:nth-child(1){
                font-size: 15px;
              }
              span:nth-child(2){
                font-size: 13px;
              }
            }
            .btmBanner{
              width: 62px;
              height: auto;
            }
          }
          .wanzhengText{
            width: 100%;
            img{
              max-width: 280px;
            }
            img:nth-child(1){
              width: 42px;
              max-width: 42px;
              height: auto;
            }
            img:nth-child(2){
              margin-top: 15px !important;
            }
          }
        }
      }
      .serveBox{
        .sbControl{
          width: 100%;
          height: auto;
          box-sizing: border-box;
          padding: 0 8px;
          flex-wrap: wrap;
          ul{
            width: 33.33%;
            height: auto;
            box-sizing: border-box;
            padding: 12px 0;
            justify-content: center;
            align-items: center;
            li{
              flex-direction: column;
              align-items: center;
              margin-bottom: 0;
              text-align: center;
              span{
                font-size: 13px;
                margin-left: 0;
                margin-top: 5px;
              }
            }
            // wap端隐藏副标题，只保留图标+标题
            li:nth-child(2){
              display: none;
            }
          }
          .ulBottom{
            border-bottom: 3px solid #d52226;
          }
        }
        .sbShow{
          .showChild{
            height: auto;
            flex-direction: column;
            justify-content: flex-start;
            > img{
              width: 100%;
              margin-top: 0;
            }
            > div{
              width: 100%;
              height: auto;
              box-sizing: border-box;
              padding: 25px 12px;
              background-size: 100% 100%;
              img{
                width: 90%;
                max-width: 386px;
                height: auto;
              }
            }
          }
        }
      }
    }
    /deep/ #box{
      margin-top: 0;
    }
  }
  
  // 设置swiper分页器的样式
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 55px;
  }
  /deep/ .swiperOne{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
    .swiperOneSpan{
      margin: 0 30px;
    }
  }
  /deep/ .swiperTwo{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 30px;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
  }
  /deep/ .swiperThree{
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      width: 4px;
      height: 4px;
      background-color: #999999;
      border-radius: 50%;
    }
    li{
      width: 20px;
      height: 20px;
      border: 2px solid #d52226;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      span{
        width: 4px;
        height: 4px;
        background-color: #d52226;
        border-radius: 50%;
      }
    }
    .swiperThreeSpan{
      margin: 0 30px;
    }
  }
</style>